export default "__VITE_ASSET__63a2fdf7__"